import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { EpisodeAttribute } from './EpisodeAttribute';
import SvgAudioDescription from '../../../../../play-core/icons/AudioDescription';
import SvgDolbyDigital from '../../../../../play-core/icons/DolbyDigital';
import SvgMultiLanguage from '../../../../../play-core/icons/MultiLanguage';
import SvgSignLanguage from '../../../../../play-core/icons/SignLanguage';
import { Colors } from '../../../../../play-core/styles/Colors';
import { Viewports } from '../../../../../play-core/styles/Viewports';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const EpisodeAttributes = ({
  program
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsxs(Layout, {
    children: [program.isLive && /*#__PURE__*/_jsx(EpisodeAttribute, {
      text: t('global.live')
    }), program.subtitlesAvailable && /*#__PURE__*/_jsx(EpisodeAttribute, {
      text: t('global.subtitleShorthand'),
      label: t('global.subtitle')
    }), program.hasSignLanguage && /*#__PURE__*/_jsx(EpisodeAttribute, {
      icon: /*#__PURE__*/_jsx(SvgSignLanguage, {}),
      label: t('global.signLanguage')
    }), program.hasTwoLanguages && /*#__PURE__*/_jsx(EpisodeAttribute, {
      icon: /*#__PURE__*/_jsx(SvgMultiLanguage, {}),
      label: t('global.twoLanguages')
    }), program.isDolbyDigital && /*#__PURE__*/_jsx(EpisodeAttribute, {
      icon: /*#__PURE__*/_jsx(SvgDolbyDigital, {}),
      label: t('global.dolbyDigital')
    }), program.hasVisualDescription && /*#__PURE__*/_jsx(EpisodeAttribute, {
      icon: /*#__PURE__*/_jsx(SvgAudioDescription, {}),
      label: t('global.audioDescription')
    })]
  });
};
const Layout = styled.div.withConfig({
  displayName: "EpisodeAttributes__Layout",
  componentId: "sc-d7lkq3-0"
})(["margin-top:30px;color:", ";display:flex;align-items:flex-start;flex-wrap:wrap;", "{flex-direction:column;}"], Colors.GREY_d2d2d2, Viewports.for('small'));